import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface Portfolio {
  id: string;
  title: string;
  description: string | null;
  portfolio_type: string;
}

export const useUserPortfolios = () => {
  const [portfolios, setPortfolios] = useState<Portfolio[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPortfolios = async () => {
      try {
        setLoading(true);
        setError(null);

        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          throw new Error('User not authenticated');
        }

        const { data, error: fetchError } = await supabase
          .from('portfolios')
          .select('id, title, description, portfolio_type')
          .eq('user_id', user.id)
          .order('created_at', { ascending: false });

        if (fetchError) throw fetchError;

        setPortfolios(data || []);
      } catch (err) {
        console.error('Error fetching portfolios:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch portfolios');
      } finally {
        setLoading(false);
      }
    };

    fetchPortfolios();
  }, []);

  return { portfolios, loading, error };
};